import { useState, useEffect } from "react";
import moment from "moment";

export const useCountdownLogic = () => {
  const currentDateTarget = () => {
    const currentDate = new Date();
    const seventhOfMay = new Date("2024-05-07 00:00");
    const mayDateTarget = new Date("2024-05-27 00:00");
    const juneDateTarget = new Date("2024-06-24 00:00");
    const julyDateTarget = new Date("2024-07-22 00:00");
    const augustDateTarget = new Date("2024-08-11 00:00");

    switch (true) {
      case currentDate <= seventhOfMay:
        return seventhOfMay;
      case currentDate <= mayDateTarget:
        return mayDateTarget;
      case currentDate <= juneDateTarget:
        return juneDateTarget;
      case currentDate <= julyDateTarget:
        return julyDateTarget;
      case currentDate <= augustDateTarget:
        return augustDateTarget;
      default:
        return null;
    }
  };

  const [remainingTime, setRemainingTime] = useState(calculateRemainingTime());

  function calculateRemainingTime() {
    const startTime = moment.utc().unix(); // use UTC timestamp in seconds
    const endTime =
      startTime +
      Number(
        moment
          .duration(moment.utc(currentDateTarget()).diff(moment.utc()))
          .asSeconds()
          .toFixed()
      ); // use UNIX timestamp in seconds
    return endTime - startTime;
  }

  useEffect(() => {
    const interval = setInterval(() => {
      setRemainingTime(calculateRemainingTime());
    }, 1000);

    return () => clearInterval(interval);
  }, [currentDateTarget]);

  const getTimeUnits = (time) => ({
    days: Math.floor(time / (24 * 60 * 60)),
    hours: Math.floor((time % (24 * 60 * 60)) / (60 * 60)),
    minutes: Math.floor((time % (60 * 60)) / 60),
    seconds: Math.floor(time % 60),
  });

  return {
    getTimeUnits,
    remainingTime,
  };
};
